import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { TextInput } from '@prisjakt/ui-inputs';
import serialize from 'form-serialize';
import { AppContext } from '@prisjakt/ui-app-context';

import SubmitButton from '../components/submit-button';
import feedbackActions from '../../feedback/actions';

import './index.scss';

const styles = bemGenerator('forgot-password', [
  'spacer',
  'feedback',
  'link',
  'back-link',
]);

class RecoverEmailPage extends React.PureComponent {
  handleSubmit(e) {
    e.preventDefault();
    const { email = '' } = serialize(e.target, { hash: true });

    this.props.validate({ email }, () => {
      this.props.passwordRecovery(email);
    });
  }

  render() {
    const { t, renderMode } = this.context;
    const { errors, pending } = this.props;

    return (
      <div className={styles.block}>
        <div className="row">
          <div className={`columns small-12 medium-6 ${styles.section}`}>
            <div className={styles.spacer}>
              <form method="post" onSubmit={e => this.handleSubmit(e)}>
                <TextInput
                  name="email"
                  label={t('account', 'input.email')}
                  warning={errors.email}
                  helper={
                    errors.email ? t('errors', errors.email[0].code) : null
                  }
                />

                <div
                  className={`${styles.spacer} ${styles.feedback.withModifier({
                    error: errors.form,
                  })}`}
                >
                  {errors.form && t('errors', errors.form[0].code)}
                </div>

                <div className={styles.spacer}>
                  <SubmitButton
                    loading={pending}
                    text={t('account', 'forgot-password.submit-button')}
                  />
                </div>
              </form>
              {renderMode !== 'native' && (
                <div className={styles.spacer}>
                  <span className={styles['contact-support']}>
                    {t('account', 'email-sent.contact-support', {
                      openFeedback: (
                        <button
                          type="button"
                          key="email-sent.contact-support"
                          className={styles.link}
                          onClick={() => this.props.feedbackToggle()}
                        >
                          {t('account', 'contact-support.link')}
                        </button>
                      ),
                    })}
                  </span>
                  <p className={styles['back-link']}>
                    {t('account', 'back-to-login.text', {
                      login: (
                        <Link
                          key="back-to-login"
                          className={styles.link}
                          to="/login"
                        >
                          {t('account', 'back-to-login.link')}
                        </Link>
                      ),
                    })}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const { bool, func, object } = PropTypes;

RecoverEmailPage.propTypes = {
  passwordRecovery: func.isRequired,
  feedbackToggle: func.isRequired,
  validate: func.isRequired,
  valid: bool,
  pending: bool,
  errors: object, // eslint-disable-line react/forbid-prop-types
};

RecoverEmailPage.defaultProps = {
  valid: false,
  errors: {},
  pending: false,
};

RecoverEmailPage.contextType = AppContext;

export default connect(
  undefined,
  {
    feedbackToggle: feedbackActions.open,
  }
)(RecoverEmailPage);
